<template lang="html">
  <div class="main--box container justify-content-center align-item-center wrap">
<!-- INICIO CARD INFORME SCORE ALUNO -->
    <div class="card--score container">
      <div class="card--score__box container justify-content-center align-item-center">
        <div class="card--score__box___msg container justify-content-center">
          <p>YOUR PARTIAL SCORE</p>
          <div class="card--score__box___msg_stars">
            <img src="@/assets/img/star-unit.svg" class="disable" alt="star" :class="{ normal : subTopic.points >= 20}">
            <img src="@/assets/img/star-unit.svg" class="disable" alt="star" :class="{ normal : subTopic.points >= 40}">
            <img src="@/assets/img/star-unit.svg" class="disable" alt="star" :class="{ normal : subTopic.points >= 51}">
            <img src="@/assets/img/star-unit.svg" class="disable" alt="star" :class="{ normal : subTopic.points >= 75}">
            <img src="@/assets/img/star-unit.svg" class="disable" alt="star" :class="{ normal : subTopic.points == 100}">
          </div>
        </div>

        <div class="card--score__box___scoreNumber card--score__box___scoreNumber__scoreGreen container justify-content-center" v-if="parseFloat(subTopic.points) >= 70">
          <p>{{parseFloat(subTopic.points).toFixed(1)}}</p>
          <span>POINTS</span>
        </div>

        <div class="card--score__box___scoreNumber card--score__box___scoreNumber__scoreRed container justify-content-center" v-else>
          <p>{{parseFloat(subTopic.points).toFixed(1)}}</p>
          <span>POINTS</span>
        </div>

      </div>
      <div class="extraScore container" v-if="!topic.speakup">
        <div id="xp" class="extraScore__base container">EXPERIENCE <span class="extraScore__base___xp">{{ parseInt(xp) }}</span> </div>
        <div id="coin" class="extraScore__base container">MDSCASH <span class="extraScore__base___coin">{{ coins ? coins : 0 }}</span></div>
      </div>
    </div>
<!-- FIM CARD INFORME SCORE ALUNO -->

<!-- INICIO CARD MENSAGEM ALUNO -->
    <div class="card--info container column">

      <div v-if="subTopic.points >= 70">
        <p class="card--info__feed">Very Well!</p>
        <p class="card--info__msgFeed">You did great performance in these exercises.</p>
        <p class="card--info__textFeed">Voce esta indo muito bem continue assim para aproveitar ao máximo o aprendizado de inglês!</p>
      </div>
      <div v-else>
        <p class="card--info__feed___ops">OOPSS!</p>
        <p class="card--info__msgFeed">You had below-average performance.</p>
        <p class="card--info__textFeed">Voce nao foi tao bem nestes exercicios, clique no  botao abaixo e revise seus erros!</p>
      </div>

      <div class="card--info__progressUnit container justify-content-between">
        <span style="flex-grow:2; flex-basis: 500px;">Progress of {{ topic.title || topic.lesson_name }}</span>


          <div class="card--info__progressUnit___barBG">
            <div class="card--info__progressUnit___barScore" :style="{ width: `${topic.percent}%` }"/>
          </div>
          <span class="card--info__progressUnit___percent">{{ noDecimals(topic.percent) }}%</span>


      </div>

      <a @click="close()" class="btn btn-full" type="button" name="button">
        SEE MY ANSWERS
        <!-- {{ (topic.percent < 100)?'Waiting 100%':`Score: ${parseFloat(topic.score.toFixed(2))}` }} -->
        <i class="iconbtn fa fa-arrow-right" aria-hidden="true"></i>
      </a>

    </div>
<!-- FIM CARD MENSAGEM ALUNO -->
  </div>
</template>

<script>
export default {
  name: "SubTopicModal",
  props: {
    questions: {
      type: Array,
      default: Array
    },
    subTopic: {
      type: Object,
      default: Object
    },
    topic: {
      type: Object,
      default: Object
    },
    close: {
      type: Function,
      default: () => console.log('Close Event!')
    }
  },
  computed: {
    xp () {
      return this.noDecimals(this.$store.getters['student/GET'].xp)
    },
    coins () {
      return this.noDecimals(this.$store.getters['student/GET'].coins)
    }
  },
  methods: {
    noDecimals (n) {
      return parseFloat(n).toFixed(0)
    }
  }
}
</script>

<style lang="scss" scoped>
// Ajustes de classe
.disable {
  filter: grayscale(100%);
}
.normal {
  filter: none;
}
.diplaynone{
  display: none!important;
}
// Fim de Ajustes de classe

  .main--box{
    width: 100%;
    height: 100%;
    border-radius: 25px;
    padding: 35px 20px;
    background: linear-gradient(0deg, #764ba2 0%, #667eea 100%);

    .card--score{
    width: 405px;
    height: 100%;
    border-radius: 30px;
    padding: 20px;
    background: linear-gradient(#ebce00 0%, #ff5700 100%);
    box-shadow: 11px 15px 14px rgba(0, 0, 0, 0.16);
    flex-direction: column;

        &__box{
          width: 100%;
          height: 100%;
          border-radius: 20px;
          background: white;

            &___msg{
              flex-grow: 1;
              flex-basis: 45%;
              padding: 0px 20px 0px 20px;
              line-height: 28px;
              flex-direction: column;
              p{
                color: #7450A9;
                font-size: 30px;
                text-align: end;
              }
              &_stars{
                // border: 1px red solid;
                text-align: end;
                  img{
                    width: 20px;
                  }
                }
            }

          &___scoreNumber{
            flex-grow: 1;
            flex-basis: 55%;
            flex-direction: column;
            padding: 0px 20px 0px 0px;
            // text-align: center;
            &__scoreGreen{
              color: #09A57E;
              font-size: 80px;
              text-align: center;
            }
            &__scoreRed{
              color: #C71A32;
              font-size: 80px;
              text-align: center;
            }
            span{
              background: #7450A9;
              // padding: 0 20px;
              margin: 5px 10px 12px 10px;
              color: white;
              font-size: 13px;
              font-weight: 300;
              border-radius: 300px;
              display: flex;
              height: 20px;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
      .extraScore{

        &__base{
          background: white;
          font-size: 13px;
          width: 100%;
          padding: 10px;
          border-radius: 15px;
          flex-grow: 1;
          flex-basis: 50%;
          text-align: center;
          align-items: center;
          justify-content: space-evenly;
          &___xp{
            background: #3087F7;
            border-radius: 300px;
            padding: 5px 10px;
            color: white!important;
            margin: 0px 5px;
            letter-spacing: 1px;
          }
          &___coin{
            background: #BC8401;
            border-radius: 300px;
            padding: 5px 10px;
            color: white!important;
            margin: 0px 5px;
            letter-spacing: 1px;
          }
        }
        & #xp{
          margin: 15px 10px 0px 0px;
          color: #3087F7;
        }
        & #coin{
          margin: 15px 0px 0px 10px;
          color: #BC8401;
        }
      }
      .card--info{
        margin-left: 30px;
        max-width: 480px;
        &__feed{
          font-size: 70px;
          color: #57FFD4;
          text-transform: uppercase;
          &___ops{
            color: #FFBEC7!important;
            font-size: 70px;
            text-transform: uppercase;
          }
        }
        &__msgFeed{
          font-size: 18px;
          font-weight: 400;
          margin-top:0px;
          color: #A5E4FF;
        }
        &__textFeed{
          font-size: 15px;
          font-weight: 200;
          margin-top: 0px;
        }
        &__progressUnit{
          font-size: 13px;
          font-weight: 200;
          margin-top: 38px;
          text-transform: uppercase;
          border: 2px solid white;
          padding: 10px;
          border-radius: 300px;
          // justify-content: space-evenly;
          align-items: center;


          &___barBG{
            background: linear-gradient(-90deg, #fff 50%, #6976df 105%);
            height: 15px;
            // width: calc(100% - 340px);
            width: 100%;
            border-radius: 300px;
            margin: 0px 0px 0px 10px;
            overflow: hidden;
          }
          &___barScore{
            background: linear-gradient(-90deg, #22ffeb 0%, #677ce7 100%);
            height: 16px;
            // width: 50px;
            border-radius: 300px;
            width: 80.63px;
            // margin: 0px 0px 0px -5px;
          }
          &___percent{
            background: white;
            color: #56308F;
            padding: 5px 10px;
            // height: 50px;
            font-size: 15px;
            border-radius: 300px;
            margin-left: 10px;
            font-weight:400;
          }
        }
        a{
          background: linear-gradient(0deg, #ff9100 0%, #df0 150%);
          border-radius: 300px;
          margin-top: 10px;
          color: #653600;
          font-weight:400;
          .iconbtn{
            margin: 0px 0px 0px 10px;
          }
        }
      }

    }

</style>



// WEBPACK FOOTER //
// src/components/modal/modalSubTopic.vue